import { Api } from '@firmable/contracts';
import { useQuery } from '@tanstack/react-query';
import { Query } from '@web/constants/query';
import * as QueryContract from '@web/contracts/Query';
import axios from 'axios';

export interface Failure {
  message: string;
}

export type FiltersApiResponse = Api.Search.Filters;

/**
 * React Query hook to get available filters
 * @returns FiltersApiResponse | undefined
 */
const useFilters = (enabled: boolean = true) => {
  return useQuery<QueryContract.Search.Filters, Failure>({
    queryKey: [Query.SearchKeys['filters'], { source: 'core' }],
    refetchOnWindowFocus: false,
    staleTime: Infinity,
    enabled: enabled,
    retry: false,
    queryFn: async () => {
      const {
        data: { groups, ...rest },
      } = await axios.get<FiltersApiResponse>(`${process.env.NEXT_PUBLIC_API_APP_ENDPOINT}/filters?module=core`);
      return {
        groups,
        ...rest,
      };
    },
  });
};

export { useFilters };
